import React from "react";
import PageFooter from "./PageFooter.jsx";
import Container from "./Container.jsx";
import PageTitle from "./PageTitle.jsx";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AuthLayout = ({ children, title, isFullWidth }) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col">
      <PageTitle title={title || "Sign in"} />
      {/* Hero section */}
      <header>
        <nav>
          <Container className="z-0 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className={"mb-2 flex h-12 items-center justify-between lg:h-16"}>
              <div className="flex flex-1 items-center justify-around">
                <NavLink to="/">
                  <span className="sr-only">{t("proof.title")}</span>
                  <img className={"h-8"} src="/images/proof-logo.png" alt={t("proof.title")} />
                </NavLink>
              </div>
            </div>
          </Container>
        </nav>
      </header>

      <main className="mb:mb-32 mb-8 grow sm:mb-16">{isFullWidth ? children : <Container>{children}</Container>}</main>
      <PageFooter />
    </div>
  );
};
export default AuthLayout;
